import { ArrowRightIcon } from "lucide-react";

import { Column } from "@/components/Column";
import { Row } from "@/components/Row";
import { Button } from "@/components/ui/button";

import { getScreenFromPathname, mixpanelUtils } from "@/lib/mixpanel/mixpanel";

export const ErrorFallback = ({ resetError }: { resetError: () => void }) => {
  const handleGoBack = () => {
    mixpanelUtils.trackButtonClick(
      "Error Go back",
      getScreenFromPathname(location.pathname),
    );
    resetError();
    window.history.back();
  };

  const handleRefresh = () => {
    mixpanelUtils.trackButtonClick(
      "Error Refresh",
      getScreenFromPathname(location.pathname),
    );
    window.location.reload();
  };

  return (
    <Column className="min-h-svh items-center justify-center">
      <Column className="gap-12">
        <Column className="gap-4">
          <p className="font-semibold text-primary-700">Error</p>
          <p className="text-6xl font-semibold text-slate-900">
            Something went wrong
          </p>
          <p className="text-xl text-slate-500">
            We encountered an error. Try refreshing or heading back.
          </p>
        </Column>
        <Row className="items-center gap-3">
          <Button
            className="rounded-full"
            onClick={handleRefresh}
            variant="outlineSecondary"
          >
            Refresh
          </Button>
          <Button className="rounded-full" onClick={handleGoBack}>
            Go back
          </Button>
        </Row>
        <Column className="items-start">
          <a
            href="mailto:team@laborup.com"
            className="flex items-center gap-2 font-semibold text-primary-800"
          >
            Contact Us <ArrowRightIcon className="h-4 w-4" />
          </a>
          <p className="text-slate-500">
            If you need any help, feel free to contact us at team@laborup.com!
          </p>
        </Column>
      </Column>
    </Column>
  );
};
